/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_4_DInputs */

const en_mk_tut_gl_4_d = /** @type {(inputs: Mk_Tut_Gl_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One pass of an agent working from start to finish, with its transcript and its cost.`)
};

const id_mk_tut_gl_4_d = /** @type {(inputs: Mk_Tut_Gl_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu kali agen bekerja dari awal sampai selesai, lengkap dengan transkrip dan biayanya.`)
};

/**
* | output |
* | --- |
* | "One pass of an agent working from start to finish, with its transcript and its cost." |
*
* @param {Mk_Tut_Gl_4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_4_d = /** @type {((inputs?: Mk_Tut_Gl_4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_4_d(inputs)
	return en_mk_tut_gl_4_d(inputs)
});